import React from 'react';

const NotFound = () => {
    return <h1>This could not be found</h1>;
};

export default NotFound;